// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import moment from 'moment'
import type { CustomerSalesReport } from './types'
import css from './thumbsUpTable.css'
type Props = {
  data: CustomerSalesReport
}

const DayRow = ({ data }: Props) => {
  const { date, target, actual } = data
  return (
    <tr key={date} className={css.dayRow}>
      <td>{moment(date).format('D.M - dd')}</td>
      <td>{Number(target).toFixed(0)}</td>
      <td>{Number(actual).toFixed(0)}</td>
    </tr>
  )
}

export default DayRow
